import Vue from 'vue'
import Router from 'vue-router'
import loginApi from "@/services/login/login";
const login = () =>
  import ( /* webpackChunkName:'login'*/ '@/pages/login/login')
const choseWeb = () =>
  import( /* webpackChunkName:'choseWeb'*/ '@/pages/choseWeb/choseWeb')
const loginOut = () =>
  import( /* webpackChunkName:'loginOut'*/ '@/pages/loginOut/out')
const forgetPwd = () =>
  import( /* webpackChunkName:'forgetPwd'*/ '@/pages/forgetPwd/forgetPwd')

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/choseWeb',
      name: 'choseWeb',
      component: choseWeb,
    },
    {
      path: '/loginOut/:status',
      name: 'loginOut',
      component: loginOut
    },
    {
      path: '/forgetPwd/:type',
      name: 'forgetPwd',
      component: forgetPwd
    },
  ]
})
//router.beforeEach(async (to, from, next) => {
  // if (localStorage.getItem("Authorization") && to.path== '/') {
  //   loginApi.isHaseToken(localStorage.getItem("Authorization"))
  //   next({ path: '/choseWeb' })
    
  // }else{
  //   next()
  // }
  //  var code = window.location.search ? window.location.search.split("&")[0].split("=")[1] : "";
  //   if (code && to.path == '/') {
  //     var res = await loginApi.qywxlogin(code)
  //     localStorage.setItem("Authorization", res.data.token);
  //     localStorage.setItem("name", res.data.userInfo.username);
  //     next({ path: '/choseWeb' })
  //   }else{
  //     next()
  //   }
//})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js